import { useState, useCallback } from 'react';
import AddressActions from 'actions/AddressActions';
import LanguageLocale from 'utils/LanguageLocale';

const { isCountryInternational } = LanguageLocale;

export function useCountryStateManagement({
    isEditMode,
    updateEditStore,
    onCountryChange,
    state,
    setAddress,
    countrySelectRef,
    stateSelectRef,
    displayCityStateInputsprop,
    setIsInternational
}) {
    const [stateList, setStateList] = useState([]);
    const [countryInvalid, setCountryInvalid] = useState(false);
    const [displayCityStateInputs, setDisplayCityStateInputs] = useState(displayCityStateInputsprop);
    const [zipCodeInvalid, setZipCodeInvalid] = useState(null);
    const [cityStateZipInvalid, setCityStateZipInvalid] = useState(false);

    const setStateListData = useCallback(
        (states, country) => {
            if (isEditMode) {
                setStateList(states);
                updateEditStore('country', country);

                if (countrySelectRef.current) {
                    countrySelectRef.current.setValue(country);
                }

                if (stateSelectRef.current && state) {
                    stateSelectRef.current.setValue(state);
                    updateEditStore('state', state);
                }
            } else {
                setStateList(states);
                updateEditStore('country', country);

                //TODO: remove countrySelect.setValue once select is fixed
                if (countrySelectRef.current) {
                    countrySelectRef.current.setValue(country);
                }
            }
        },
        [isEditMode, state, updateEditStore]
    );

    const resetCountryAndStateInfo = useCallback(
        (country, stateListData, international) => {
            setStateList(stateListData);
            setIsInternational(international);
            setDisplayCityStateInputs(false);
            setZipCodeInvalid(null);
            setAddress(prev => ({
                ...prev,
                phone: '',
                formattedPhone: ''
            }));
            updateEditStore('country', country);
            updateEditStore('state', '');
            updateEditStore('city', '');
            updateEditStore('postalCode', '');

            if (onCountryChange) {
                onCountryChange(country);
            }
        },
        [updateEditStore, onCountryChange, setStateList, setIsInternational, setDisplayCityStateInputs, setZipCodeInvalid, setAddress]
    );

    const handleCityOnChange = useCallback(
        e => {
            updateEditStore(e.target.name, e.target.value);
            setCityStateZipInvalid(null);
        },
        [updateEditStore]
    );

    const handleStateSelect = useCallback(
        e => {
            updateEditStore('state', e.target.value);
            setCityStateZipInvalid(null);
        },
        [updateEditStore]
    );

    const handleCountrySelect = useCallback(
        e => {
            const country = e.target.value;
            const international = isCountryInternational(country);

            if (!international) {
                AddressActions.getStateList(country, states => resetCountryAndStateInfo(country, states, international));
            } else {
                resetCountryAndStateInfo(country, null, international);
            }
        },
        [resetCountryAndStateInfo]
    );

    return {
        stateList,
        countryInvalid,
        resetCountryAndStateInfo,
        setStateListData,
        displayCityStateInputs,
        zipCodeInvalid,
        setCountryInvalid,
        setIsInternational,
        setDisplayCityStateInputs,
        setZipCodeInvalid,
        cityStateZipInvalid,
        setCityStateZipInvalid,
        handleCityOnChange,
        handleStateSelect,
        handleCountrySelect
    };
}
